import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgCursor = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 54,
	height: 54,
	viewBox: "0 0 54 54",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("path", {
			d: "M26.9997 54L50.456 40.5L26.9997 27L3.54346 40.5L26.9997 54Z",
			fill: "url(#paint0_linear_117153_267)"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M50.4565 40.5V13.5L27.0002 0V27L50.4565 40.5Z",
			fill: "url(#paint1_linear_117153_267)"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M26.9997 0L3.54346 13.5V40.5L26.9997 27V0Z",
			fill: "url(#paint2_linear_117153_267)"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M50.4565 13.5L27.0002 54V27L50.4565 13.5Z",
			fill: "#555555"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M50.456 13.5L26.9997 27L3.54346 13.5H50.456Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsxs("defs", { children: [
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "paint0_linear_117153_267",
				x1: 26.9997,
				y1: 27,
				x2: 26.9997,
				y2: 54,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", {
					offset: .16,
					stopOpacity: .39
				}), /* @__PURE__ */ _jsx("stop", {
					offset: .658,
					stopOpacity: .8
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "paint1_linear_117153_267",
				x1: 50.4565,
				y1: 13.5833,
				x2: 27.0002,
				y2: 27.3375,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", {
					offset: .182,
					stopOpacity: .31
				}), /* @__PURE__ */ _jsx("stop", {
					offset: .715,
					stopOpacity: 0
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "paint2_linear_117153_267",
				x1: 26.9997,
				y1: -6.99051e-7,
				x2: 3.54346,
				y2: 40.5,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopOpacity: .6 }), /* @__PURE__ */ _jsx("stop", {
					offset: .667,
					stopOpacity: .22
				})]
			})
		] })
	]
});
const ForwardRef = forwardRef(SvgCursor);
export { ForwardRef as ReactComponent };
